'use es6';

import PropTypes from 'prop-types';
import { getFullHref } from '../util/History';
import { jsx as _jsx } from "react/jsx-runtime";
const Canonical = ({
  rel,
  to
}) => {
  return /*#__PURE__*/_jsx("link", {
    rel: rel,
    href: getFullHref(to)
  });
};
Canonical.propTypes = {
  rel: PropTypes.oneOf(['canonical', 'next', 'prev']),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
Canonical.defaultProps = {
  rel: 'canonical'
};
export default Canonical;